import { useLocation } from 'react-router-dom';
import React, { createContext, useContext, useEffect } from 'react';
import { Analytics } from './Analytics';
import { pushToMtm } from './mtm';

declare global {
  interface Window {
    _mtm: any[];
  }
}

export interface AnalyticsContextProps {
  analytics: Analytics;
}

const defaultAnalyticsContext = {
  analytics: new Analytics(),
};

export const AnalyticsContext = createContext<AnalyticsContextProps>(
  defaultAnalyticsContext,
);

interface AnalyticsProviderProps {
  children: React.ReactNode;
  container: string;
}

export const AnalyticsProvider: React.FC<AnalyticsProviderProps> = ({
  children,
  container,
}) => {
  const location = useLocation();
  useEffect(() => {
    if (window.location.hostname === 'localhost') return;
    pushToMtm({ 'mtm.startTime': new Date().getTime(), event: 'mtm.Start' });
    const d = document;
    const script = d.createElement('script');
    const firstScriptTag = d.getElementsByTagName('script')[0];
    script.async = true;
    script.src = `https://analytics.bilendi.com/js/container_${container}.js`;
    firstScriptTag.parentNode?.insertBefore(script, firstScriptTag);
  }, [container]);

  useEffect(() => {
    setTimeout(async () => {
      pushToMtm({
        event: 'react-page-changed',
        location: location.pathname,
        search: location.search,
        hash: location.hash,
      });
    }, 300);
  }, [location]);

  return <>{children}</>;
};

export const useAnalyticsContext = () => useContext(AnalyticsContext);
